import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";
import { AdminPublicInfo, BalanceResponse } from "./models";

export const fetchAdminPublicInfo = async (): Promise<AdminPublicInfo | null> => {
    let config = getConfig()
    let result: AdminPublicInfo | null = null
    try {
        await axios.get(`/getAdminPublicInfo`, config)
            .then((res) => {
                result = res.data || []
            })
    } catch (error) {
        console.log(error)
    }

    if (result) {
        return result as AdminPublicInfo
    }

    return null
}


export const fetchAdminBalance = async (): Promise<BalanceResponse | null> => {
    let config = getConfig()
    let result: BalanceResponse | null = null
    try {

        await axios.get(`/balance`, config)
            .then((res) => {
                result = res.data || null
            })
    } catch (error) {
        console.log(error)
    }

    return result
}

export const getPaymentScaleUsers = async () => {
    let config = getConfig()
    let result;
    try {
        await axios.get(`/getPaymentScaleUser`, config)

            .then((res) => {
                result = res?.data ?? '';
            })
    } catch (error) {
        console.log(error)
    }

    return result
}

export const getPaymentScaleAdmin = async () => {
    let config = getConfig()
    let result;
    try {

        await axios.get(`/admin/getPaymentScale`, config)

            .then((res) => {
                result = res?.data ?? '';
            })
    } catch (error) {
        console.log(error)
    }

    return result
}

export const editPaymentScale = async ({ newContent }: { newContent: string }) => {
    let config = getConfig()
    const body = {
        content: newContent
    }

    try {
        let result = await axios.post(`/admin/editPaymentScale`, body, config)
        return result;
    } catch (error) {
        console.log(error)
        return error
    }
}
